import React from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import { setGlobalLoading } from 'redux/actions/actionCommon'

function MailchimpSettings(props) {
    // const formik = useFormik({
    //     // initialValues: initialEditFormValues,
    //     // validationSchema: editFormValidationSchema,
    //     // onSubmit: onEditFormSubmit,
    //     // enableReinitialize: true
    // })

    return (
        <section id="app-quickbook-settings" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-integrations">
                    <Col xs={12} md={12} lg={12} className="px-0">
                        <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block pad-12">
                                <div className="integrations-bottom-content justify-content-between">
                                    <div className="card-content">
                                        <div className="quickbook-settings-content">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Product Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    Select how products should be named in QuickBooks.Products attached to orders  will be created or matched in QuickBooks based on name.If a product is not found, a new one will be created.
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline"><input type="radio" className="me-2" id="active"
                                                            // {...formik.getFieldProps('active')}
                                                            // value="1"
                                                            // onChange={e => {
                                                            //     formik.setFieldValue("active", e.target.value)
                                                            // }}
                                                            /> {` Title and varient`}
                                                            </span>
                                                            <span className="d-flex st-fw-600 align-items-baseline"><input type="radio" className="me-2" id="active"
                                                            // {...formik.getFieldProps('active')}
                                                            // value="0"
                                                            // onChange={e => {
                                                            //     formik.setFieldValue("active", e.target.value)
                                                            // }}
                                                            />{`SKU matched against the QuickBooks item NAME field.`}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quickbook-settings-content">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Customer Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    Customer Data attached to orders will be exported to QuickBooks Online.
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="radio" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="1"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                /> {` Export customers to QuickBooks Online `}
                                                            </span>
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="radio" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="0"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                />{` Do not export customersto QuickBooks Online. Instead, a single Shopify Customer-Quick Bookkeeping & Accounting: QuickBooks Solution Provider customer will be used for all others. `}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quickbook-settings-content">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    You can schedule automatic daily exports and configure notification emails
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="checkbox" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="1"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                /> {` Automatic export daily (after midnight ) `}
                                                            </span>
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="checkbox" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="0"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                />{` Receive export notifications by email `}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quickbook-settings-content ">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    You can schedule automatic daily exports and configure notification emails
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="checkbox" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="1"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                /> {`When an Order is created in Shopify, create a Sale in QuickBooks Online`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quickbook-settings-content ">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    You can schedule automatic daily exports and configure notification emails
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="checkbox" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="1"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                /> {`When a Payout is paid by Shopify, create a Deposit in QuickBooks Online`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quickbook-settings-content ">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    You can schedule automatic daily exports and configure notification emails
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="checkbox" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="1"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                /> {`When a Product is created in Shopify, create a new Item in QuickBooks Online`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quickbook-settings-content border-bottom">
                                            <div className="content-right">
                                                <div className="d-flex align-items-center " >
                                                    <span className="app-heading text-capitalize me-3">Export Settings</span>
                                                </div>
                                                <p className="app-integrations-desc pad-12-T">
                                                    You can schedule automatic daily exports and configure notification emails
                                                </p>

                                            </div>
                                            <div className="content-left">
                                                <div className="app-card-content border st-default-rounded-block pad-12">
                                                    <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                                                        <div className="media-body st-form-input-container align-left">
                                                            <span className="d-flex st-fw-600 align-items-baseline">
                                                                <input type="checkbox" className="me-2" id="active"
                                                                // {...formik.getFieldProps('active')}
                                                                // value="1"
                                                                // onChange={e => {
                                                                //     formik.setFieldValue("active", e.target.value)
                                                                // }}
                                                                /> {`When Stock Levels are updated in QuickBooks Online, update Stock Levels in Shopify`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex mt-3 justify-content-end">
                                            <button
                                                className="st-btn st-btn-primary st-btn-xs d-flex align-items-center justify-content-center"
                                            >Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(MailchimpSettings)